export default __webpack_public_path__ + "static/media/close_dialog.40acfb2b.svg";